import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { links } from '@shared/utils';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Sended = () => {
  return (
    <Flex flexDir="column" w="full" p={10} maxH="100dvh" h="100%" bg="brand.50">
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        gap={6}
        w="full"
        h="100dvh"
      >
        <Image
          src="/images/logo-nexpro-connect.jpeg"
          blendMode="darken"
          h={130}
        />
        <Text size="2xl" fontWeight="semibold" maxW={400} textAlign="center">
          Seus dados foram enviados para análise. Você será notificado por
          email.
        </Text>

        <Button
          variant="link"
          colorScheme="brand"
          size="lg"
          w={360}
          as={Link}
          to={links.portal}
          leftIcon={<ArrowLeftIcon />}
        >
          Voltar para o site
        </Button>
      </Flex>
    </Flex>
  );
};
